<p-dialog appendTo="body" width="getResolutionWidth()" header="CAT Recon Comment Viewer" [(visible)]="catReconService.isOpenCommentViewer"
  modal="true" [maximizable]="true" (onHide)="closeDialogbox()" scrollTop="true"
  id="catReconCommentViewer" [style]="{width: '60%', minWidth: '70%', overflow:'inherit' }"
  [position]="'top'" >
  <div>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <!-- Filter Code -->
      <div>
        <div>
          <div class="col-lg-12 nopadding">
            <mat-chip-listbox aria-label="filter">
              <span>
                @if(catReconService.isDisplayDateRangeFilter){
                <button id="dateButton" type="button" class="date-btn" (click)="showDateFilter()">
                  {{LastExecutionDate[0] === LastExecutionDate[1] || LastExecutionDate[1] === null ? 
                    this.userService.getyyyyMMddDateFormate(LastExecutionDate[0]) : 
                    this.userService.getyyyyMMddDateFormate(LastExecutionDate[0]) + ',' + 
                    this.userService.getyyyyMMddDateFormate(LastExecutionDate[1])}}
                </button>}
                @for (staticFilter of staticAvailableFilters; track staticFilter;){
                <mat-chip selected [matTooltip]="staticFilter.filterName" [matTooltipShowDelay]="1000"
                  matTooltipPosition="after" id="parent-child-event-tree-symbol">
                  {{staticFilter.filterName}}: {{staticFilter.filterValue}}
                </mat-chip>}
              </span>
            </mat-chip-listbox>
          </div>
        </div>
      </div>
    </mat-accordion>
  </div>
  <div class="ui-grid-col-12">
    @if(isDataLoading){
    <div class="example-loading-shade">
      @if(isDataLoading){<mat-spinner></mat-spinner>}
    </div>}
    <p-table #dt 
      emptyMessage="tbldatamsg"
      [value]="catReconCommentData" 
      [columns]="cols" 
      [resizableColumns]="true"
      [lazy]="true"  
      columnResizeMode="expand"  
      [(selection)]="this.dataService.roeSelectedRecords" 
      (selectionChange)="onSelectionChange($event)" 
      [paginator]="true" 
      appendTo="body" 
      alwaysShowPaginator="true" 
      paginatorPosition="both"
      showCurrentPageReport="true" 
      (onPage)="changePage($event)" 
      [rows]="rowcount" 
      [totalRecords]="totalRecords"
      [pageLinks]="constantService.DEFAULT_PAGELINKS" 
      [sortOrder]="constantService.DEFAULT_SORDORDER_ASC"
      sortMode="multiple"
      (onSort)="sort($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      paginatorDropdownAppendTo="body"
      id="catReconCommentData">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td class="text-center" [attr.colspan]="columns.length">
            {{isDataLoading?constantService.LOADIND_DATA_MSG:constantService.NO_RECORDFOUND_MSG}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th id="tableCheckbox" style="width: 3em">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          @for(col of cols; track col; let i = $index) {
          <th [id]="col.header"
          [ngClass]="(col?.display | lowercase) === 'false' ? 'notdisplay':'' " pResizableColumn [pSortableColumn]="col.field">
            <span>
              {{col.header}}
              @if((col.header | lowercase) !== 'action'){
              <p-sortIcon [field]="col.field"></p-sortIcon>}
            </span>
          </th>}
        </tr>
        <tr>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td style="width: 3em;padding-left: 6px !important;" [class.ui-row-highlight]="rowData['isActive']===false">
            <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="rowData" [disabled]="(rowData['isActive']===false ? true : false)"></p-tableCheckbox>
          </td>
          @for(col of columns; track col; let i = $index) {
          <td [ngClass]="(col?.display | lowercase) === 'false' ? 'notdisplay' : ''" [class.ui-row-highlight]="rowData['isActive']===false">
            <!-- set Date -->
             @if((col.datatype | lowercase)==='date'){
            <span>
              @if(rowData[col.field] && rowData[col.field]!='null'){
              <span>{{rowData[col.field] | date: 'yyyy-MM-dd'}}</span>}
            </span>}

            <!-- set String -->
             @if((col.datatype | lowercase)==='string'){
            <span>
              @if(rowData[col.field]!='null' && rowData[col.field]!=''){
              <span >{{rowData[col.field] }}</span>}
            </span>}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorright">
        <button type="button" matTooltip="Delete" [matTooltipShowDelay]="1000" 
        id="delete-catrecon-comments" label="delete-catrecon-comments"
          class="exportBtn" (click)="removeRecords($event)"> Delete <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" matTooltip="Export" [matTooltipShowDelay]="1000"
         id="export-catrecon-comments" label="export-catrecon-comments"
          class="exportBtn" (click)="exportToCSV()"> Export <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        Total Records: {{totalRecords}}
      </ng-template>
    </p-table>
  </div>
  <!-- Add Comment Box -->
   @if(catReconService.isDisplayAddCommentForm){
    <div>
      <form name="addCommentForm" #ProcessFlow="ngForm" novalidate>
        <div class="ui-grid ui-grid-responsive">
          <div class="ui-grid-col-1">
            <label id="commentTitle" for="commentTitle">Comment</label>
          </div>
          <div class="ui-grid-col-9">
            <textarea pInputTextarea [required]="true" [maxLength]="maxCharsLength" [(ngModel)]="commentStatement" class="width-100"
              name="userComment" id="userComment"></textarea>
          </div>
          <div class="ui-grid-col-2 ui-g-nopad">
            <div class="ui-g">
              <div class="ui-g-1"></div>
              <div class="ui-g-10">
                <button pButton type="button" id="AddComment" [disabled]="ProcessFlow.invalid" label="Add Comment"
                  icon="fa fa-check" class="ui-button-info btn-style" (click)="addReconComment();"></button>
              </div>
              <div class="ui-g-1"></div>
            </div>
          </div>
        </div>
        <div class="ui-grid ui-grid-responsive">
          <div class="text-right ui-grid-col-10">
            <span class="charsCounter"> Characters Remaining: 
              {{((commentStatement && commentStatement.length > 0) ? (maxCharsLength-commentStatement.length) : maxCharsLength)}}</span>
          </div>
          <div class="ui-grid-col-2"></div>
        </div>
      </form>
    </div>}
  <!-- End of Adding Comment Box -->
    <ng-template #footer>
    <button pButton type="button" id="catrecon-comment-close" icon="fa fa-close" (click)="closeDialogbox()" label="Close" class="ui-button-secondary userActionBtn" style="background: #e54a23 !important;"></button>
    </ng-template>
</p-dialog>

<!-- Confirmation Box -->
  <p-confirmDialog 
    id="catReconActionComfirmation"
    rejectLabel="No"
    acceptLabel="Ok" 
    key="DeleteconfirmationDialoge"
    appendTo="body" 
    header="Information" 
    icon="pi pi-exclamation-triangle" 
    [baseZIndex]="999999"
    styleClass="catReconDialogBox"
    >
  </p-confirmDialog>
<!-- End of Confirmation Box -->
<!-- Date Range Filter -->
  <p-dialog [(visible)]="isOpenDateRangeFilter" styleClass="quick-view-grid-row" icon="pi pi-exclamation-triangle"
  width="425" minHeight="0" appendTo="body" showEffect="fade" [modal]="true" (onHide)="isOpenDateRangeFilter = false"
  header="Date Filter" id="dateRangeFilter">
    <div class="col-lg-12">
      <div class="col-lg-4"><label id="reportDate" for="reportDate">Report Date</label></div>
      <div class="col-lg-8">
        <app-datepicker-calendar [dateRange]="filterReportDate" [isDateRange]="true" (dateChange)="getDateEmitter()"></app-datepicker-calendar>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="col-lg-4"></div>
      <div class="col-lg-8">
        <button type="button" class="btn-DodgerBlue mg-t-5 float-right" id="ApplyFilter"
          (click)="applyFilter();isOpenDateRangeFilter=false;">Apply Filter
        </button>
      </div>
    </div>
  </p-dialog>
<!-- End of Filter -->